<template>
    <div class="template-card change-info">
        <h3 class="dmv-text dmv-text-primary dmv-text-large title">
            {{resource('DmVisualizer_Templates_Your_Data_Title')}}
        </h3>

        <p class="dmv-text dmv-text-secondary">
            {{resource('DmVisualizer_Templates_Your_Data_Text_Part1')}}
        </p>

        <p class="dmv-text dmv-text-secondary">
            {{resource('DmVisualizer_Templates_Your_Data_Text_Part2')}}
        </p>
        <a class="btn btn-lg btn-outline-primary change-info-btn" @click="$emit('trigger-change-info')">
             {{resource('DmVisualizer_Templates_Change_Data_Button_Text')}}
        </a>
    </div>
</template>

<script>   
    import resourceMixin from '../../../../Util/Mixins/resources';

    import dmVisualizerApi from '../../../../Api/dm-visualizer';
    
    export default {
        name: "scenario-templates-change-info",
        mixins: [resourceMixin]
    };
</script>

<style scoped src="../../Style/scenario-change-info.scss" lang="scss">
    
</style>
